import { gql } from "@apollo/client";
import { TRAVEL_RESERVATION_NOTE_FRAGMENT } from "./queries";

const TOUR_CANCELLATION_QUOTE_FIELDS = `
  saleOrderCode
  canCancel
  alreadyCancelled
  outcomeUncertain
  status
  errorCode
  errorMessage
  cancellationAmount
  currency
  generatedAtUtc
  refundProcessingImplemented
  refundStatus
`;

/**
 * Served on the platform travel schema (travel admin client), not the default one.
 * Runs a live provider simulation, which is why it is a mutation.
 */
export const REQUEST_TOUR_CANCELLATION_QUOTE = gql`
  mutation RequestTourCancellationQuote($saleOrderCode: String!) {
    requestTourCancellationQuote(saleOrderCode: $saleOrderCode) {
      ${TOUR_CANCELLATION_QUOTE_FIELDS}
    }
  }
`;

/** Served on the platform travel schema (travel admin client). The only provider write. */
export const CANCEL_TOUR_RESERVATION = gql`
  mutation CancelTourReservation(
    $saleOrderCode: String!
    $request: TourOrderCancellationRequestInput!
  ) {
    cancelTourReservation(saleOrderCode: $saleOrderCode, request: $request) {
      saleOrderCode
      succeeded
      alreadyCancelled
      outcomeUncertain
      requiresReconfirmation
      status
      errorCode
      errorMessage
      cancellationAmount
      currency
      localStateSynchronized
      cancelledAtUtc
      refundProcessingImplemented
      refundStatus
    }
  }
`;

export const ADD_TRAVEL_RESERVATION_NOTE = gql`
  ${TRAVEL_RESERVATION_NOTE_FRAGMENT}
  mutation AddTravelReservationNote($id: String!, $content: String!) {
    addTravelReservationNote(id: $id, content: $content) {
      ...TravelReservationNoteFields
    }
  }
`;

export const RESEND_TRAVEL_RESERVATION_CONFIRMATION_EMAIL = gql`
  mutation ResendTravelReservationConfirmationEmail($id: String!) {
    resendTravelReservationConfirmationEmail(id: $id)
  }
`;
